import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'cass-display-products-list',
	templateUrl: './display-products-list.component.html',
	styleUrls: ['./display-products-list.component.css']
})
export class DisplayProductsListComponent implements OnInit {

	@Input()
	get productNames(): string[] | undefined {
		return this._productNames;
	}
	set productNames(productNames: string[] | undefined) {
		this._productNames = productNames;
	}
	private _productNames: string[] | undefined;

	constructor() { }

	ngOnInit(): void {
	}
}
